import BSC from './BSC.svg';
import ETH from './ETH.png';
import CRO from './CRO.png';
import TCRO from './CRO.png';
import TBSC from './BSC.svg';
import AVAXC from './AVAX.svg';

const images = {
    BSC,
    ETH,
    CRO,
    TCRO,
    TBSC,
    AVAXC
}

export default images;